
/**
 * Module dependencies.
 */

import { units } from 'src/styles/utils';
import { useFiltersList } from 'src/context/filters-list/context';
import BaseCheckbox from 'src/components/core/checkbox';
import React, { ReactElement, ReactNode, useCallback } from 'react';
import styled from 'styled-components';

/**
 * `Props` type.
 */

type Props = {
  className?: string,
  label: ReactNode,
  name: string,
  value: string | number | boolean
};

/**
 * `StyledCheckbox` styled component.
 */

const StyledCheckbox = styled(BaseCheckbox).attrs({ reverse: true })`
  padding: ${units(1)} 0;
`;

/**
 * `FilterItem` component.
 */

const FilterItem = (props: Props): ReactElement => {
  const { className, label, name, value } = props;
  const { isFilterSelected, onAddRemove } = useFiltersList();
  const handleChange = useCallback(event => {
    const { checked, value } = event.target;
    const action = checked ? 'add' : 'remove';

    onAddRemove(name, value, action);
  }, [name, onAddRemove]);

  return (
    <StyledCheckbox
      checked={isFilterSelected(name, value)}
      className={className}
      label={label}
      name={name}
      onChange={handleChange}
      value={value}
    />
  );
};

/**
 * Export `FilterItem` component.
 */

export default FilterItem;
